import React from 'react';
import MenuItem from './MenuItem';

interface Props {
  list: Array<string>;
  selected: string;
  locale: any;
}

const Menu = (list, selected, locale): Props =>
  list.map((el: { name: string; calendar?: boolean; has_tickets?: boolean }) => {
    const { name, calendar } = el;
    const isSelected = selected === name;

    return (
      <MenuItem
        text={name}
        key={name}
        selected={isSelected}
        locale={locale}
        calendar={calendar}
        hasTickets={el.has_tickets}
      />
    );
  });

export default Menu;
